/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteSurveyQuestion$Params {

/**
 * id of surveyquestion to delete
 */
  surveyQuestionId: number;
}

export function deleteSurveyQuestion(http: HttpClient, rootUrl: string, params: DeleteSurveyQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteSurveyQuestion.PATH, 'delete');
  if (params) {
    rb.path('surveyQuestionId', params.surveyQuestionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteSurveyQuestion.PATH = '/api/SurveyQuestion/{surveyQuestionId}';
